module.exports = __webpack_public_path__ + "img/home_page.6e249388.jpg";